module.exports = __webpack_public_path__ + "static/media/introHappy2025.944d0e8b.png";